import styled from 'styled-components';

export const ConfigContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 500px;
  padding: 2rem;
`;

export const ConfigCard = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  max-width: 700px;
  width: 100%;
`;

export const ConfigHeader = styled.div`
  text-align: center;
  margin-bottom: 2rem;
  
  h3 {
    margin: 1rem 0 0 0;
    color: #333;
    font-size: 1.5rem;
    font-weight: 600;
  }
`;

export const ConfigContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const ConfigSection = styled.div`
  h4 {
    margin: 0 0 1rem 0;
    color: #333;
    font-size: 1.1rem;
    font-weight: 600;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 0.5rem;
  }
`;

export const ConfigField = styled.div`
  margin-bottom: 1.5rem;
`;

export const ConfigLabel = styled.label`
  display: block;
  margin-bottom: 0.5rem;
  color: #333;
  font-weight: 500;
  font-size: 0.9rem;
`;

export const ConfigInput = styled.div`
  position: relative;
`;

export const ConfigInfo = styled.small`
  display: block;
  margin-top: 0.25rem;
  color: #666;
  font-size: 0.8rem;
`;

export const ConfigToggle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  
  span {
    color: #333;
    font-size: 0.9rem;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid #e0e0e0;
`;

export const StatusIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem;
  background: #f8f9fa;
  border-radius: 6px;
  border-left: 4px solid #00C48C;
  
  span {
    color: #333;
    font-weight: 500;
    font-size: 0.9rem;
  }
`;

export const SyncStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  background: #e3f2fd;
  border-radius: 8px;
  border-left: 4px solid #2196f3;
  margin-bottom: 1rem;
  
  span {
    color: #1976d2;
    font-weight: 500;
    font-size: 0.9rem;
  }
`;
